import { createContext } from 'react'

export const ReactAlertContext = createContext()
